import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Button } from './Button';
import { PreClassActivity } from './CountdownWidget/CountdownWidgetContent';
import { LiveClassTag, LiveClassType } from './LiveClassTag';

export interface LiveClassShiftListItemProps {
  title: string;
  type: LiveClassType;
  dateTime?: string;
  onClick?: () => void;
  className?: string;
  topicId?: number;
  liveClassId?: number;
  preClassActivities?: PreClassActivity[];
}

export const LiveClassShiftListItem: React.FC<LiveClassShiftListItemProps> = ({
  title,
  type,
  onClick,
  className,
}) => {
  const __ = useTranslation().t;
  const buttonText = __('book');

  return (
    <Container className={className}>
      <StyledContent>
        <StyledText>{title}</StyledText>
        <LiveClassTag type={type} />
      </StyledContent>
      <Button label={buttonText} outline variant="primary" size="sm" onClick={onClick} />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.backgroundDark};
  border-radius: 8px;
`;

const StyledContent = styled.div`
  flex: 1;
  min-width: 0px;
  padding-right: 8px;
`;

const StyledText = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary.regular.fontFamily};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: '#000000';
  margin-bottom: 2px;
`;
